var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlitzquizI(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.82 133",
    id: "letter-i",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "progstroke",
    d: "M60.8,18c0,17.3,0,34.7,0,52c0,16.6,0,33.1,0,49.7H12.7c0-17,0-33.9,0-50.9c0-16.9,0-33.9,0-50.8 c7.6-0.2,15.3-0.3,23.3-0.3C44.5,17.7,52.8,17.8,60.8,18z",
    "data-squeezed": "M61,24c5,16,5,27.4,5,44.7c0,16.6-5.2,34.5-5.2,51H12.7c0-17-6.1-36.2-6.1-53.2c0-16.9,1.7-27.8,5.9-43.2 c5.8,5,15.4,10,23.4,10C44.4,33.3,52.3,29,61,24z",
    "data-squeezed_up": "M57.3,17.9c-3,16.8-4.8,33.1-2.8,50.8c1.9,16.5,6.3,34.5,6.3,51H12.7c0-17,2-33,3.9-49.9 c2-17.8,3.5-34.6-0.6-52.2c7.7-3.3,12-5.3,19.9-5.3C44.4,12.3,51,14.3,57.3,17.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlitzquizI);
export default __webpack_public_path__ + "static/media/glitzquiz-i.8db7288801b54979ad3451768f77119e.svg";
export { ForwardRef as ReactComponent };